module.exports = __webpack_public_path__ + "static/media/VestasSans-Thin.b795b465.eot";